import { render, staticRenderFns } from "./AdvancedWebsitePreview.vue?vue&type=template&id=bdd69850&scoped=true"
import script from "./AdvancedWebsitePreview.vue?vue&type=script&lang=js"
export * from "./AdvancedWebsitePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd69850",
  null
  
)

export default component.exports